import { RefundService } from "../../utils/ServiceLocator";
import { getToken } from "../../utils/AdalConfig";

/**
 * Exports USPI refunds to Excel for a center.
 * Returns the blob and filename for download.
 */
export async function exportUspiRefunds(centerId: string): Promise<{ blob: Blob; filename: string }> {
    const token = getToken();
    const response = await fetch(`${RefundService}uspi-export/${centerId}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error(`Export failed: ${response.statusText}`);
    }

    // Extract filename from Content-Disposition header or generate default
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = `${centerId}_REFUNDS_${formatDate(new Date())}.xlsx`;
    
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
    }

    const blob = await response.blob();
    return { blob, filename };
}

/**
 * Triggers browser download for the given blob.
 */
export function downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}
